<label>
  <!-- tell prettier to not insert whitespaces -->
  <!-- display: inline -->
  <div class="form-field__label form-field__summary-label">
    @if (field?.label; as label) {
      {{ label | translateInline }}
    }
  </div>

  @for (item of items$ | async; track item.value) {
    <div
      class="form-field__checkbox-summary"
      [class.form-field__checkbox-summary--checked]="item.checked"
    >
      <fa-icon
        [icon]="item.checked ? iconChecked : iconUnchecked"
        class="form-field__checkbox-summary-icon"
      ></fa-icon>
      <div>
        <div class="form-field__checkbox-summary-label">
          {{ item.label | translateInline }}
        </div>
        @if (item.description; as description) {
          <div class="form-field__checkbox-summary-description">
            {{ description | translateInline }}
          </div>
        }
      </div>
    </div>
  }
</label>
